import React, { FC } from 'react'

export const WinkActiveSvg: FC<{ size?: number; id?: string }> = ({
  size = 40,
  id,
}) => (
  <svg width={size} height={size} viewBox="0 0 40 40">
    <defs>
      <linearGradient
        id={`z8cfhi8lca_${id}`}
        x1="50%"
        x2="50%"
        y1="-5.28%"
        y2="118.765%"
      >
        <stop offset="0%" stopColor="#FED576" />
        <stop offset="100%" stopColor="#FFB55A" />
      </linearGradient>
      <linearGradient
        id={`v5vbv9htib_${id}`}
        x1="40.312%"
        x2="82.3%"
        y1="1.847%"
        y2="82.217%"
      >
        <stop offset="0%" stopColor="#5B7080" />
        <stop offset="100%" stopColor="#2E3D49" />
      </linearGradient>
      <linearGradient
        id={`jfhb6piifc_${id}`}
        x1="50%"
        x2="50%"
        y1="-87.57%"
        y2="100%"
      >
        <stop offset="0%" stopColor="#5B7080" />
        <stop offset="100%" stopColor="#2E3D49" />
      </linearGradient>
      <linearGradient
        id={`rg6zag3vje_${id}`}
        x1="50%"
        x2="50%"
        y1="223.205%"
        y2="0%"
      >
        <stop offset="0%" stopColor="#5B7080" />
        <stop offset="100%" stopColor="#2E3D49" />
      </linearGradient>
      <linearGradient
        id={`83djg3c17f_${id}`}
        x1="50%"
        x2="50%"
        y1="-86.956%"
        y2="99.792%"
      >
        <stop offset="0%" stopColor="#E6825B" />
        <stop offset="99.945%" stopColor="#803737" />
      </linearGradient>
      <path
        id={`bg00u6je7d_${id}`}
        d="M15.724 4.127c0-.003-.002-.004-.004-.006-.08-.129-.177-.241-.286-.337-3.32-3.93-7.32-3.783-7.32-3.783C2.76 0 .38 3.96.38 3.96.145 4.247 0 4.633 0 5.059 0 5.944.617 6.66 1.38 6.66c.252 0 .485-.085.689-.222 6.073-1.825 12.06.118 12.065.12.148.063.305.102.472.102.762 0 1.38-.717 1.38-1.602 0-.349-.099-.67-.262-.932"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <g transform="translate(-639 -1128) translate(639 1128) translate(.466 .466)">
            <circle
              cx="19.483"
              cy="19.483"
              r="19.483"
              fill={`url(#z8cfhi8lca_${id})`}
            />
            <path
              stroke={`url(#v5vbv9htib_${id})`}
              strokeLinecap="round"
              strokeWidth="1.332"
              d="M30.173 18.783l-5.663-1.84c-.35-.114-.541-.49-.427-.84.073-.224.26-.393.49-.444l5.6-1.233h0"
            />
            <circle
              cx="12.356"
              cy="16.186"
              r="2.598"
              fill={`url(#jfhb6piifc_${id})`}
            />
            <g transform="translate(11.49 25.877)">
              <mask id={`6j4auht2pg_${id}`} fill="#fff">
                <use xlinkHref={`#bg00u6je7d_${id}`} />
              </mask>
              <use
                fill={`url(#rg6zag3vje_${id})`}
                transform="rotate(-180 7.993 3.33)"
                xlinkHref={`#bg00u6je7d_${id}`}
              />
              <ellipse
                cx="8.026"
                cy="6.627"
                fill={`url(#83djg3c17f_${id})`}
                mask={`url(#6j4auht2pg_${id})`}
                rx="4.663"
                ry="2.997"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)
